<div class="login-signup-box popout-register">
    <div class="modal-body">
        <form [formGroup]="forgotPasswordForm">
            <h3 id="forgot-password-title" class="sr-only">Forgot Password</h3>
            <p><strong>Forgot Password</strong></p>
            <div class="form-group">
                <div class="text-box-wrap" *ngIf="selectedHelpType !== passwordResetType.ResetPassword">
                    <label for="forgotEmail" class="sr-only">Email Address</label>
                    <input type="email" id="forgotEmail" formControlName="email" class="form-control" maxlength="50" (keyup)="trimEmail()"
                        placeholder="Email Address" autocomplete="email" aria-required="true"
                        [ngClass]="{'is-invalid': formErrors.email}"
                        [attr.aria-invalid]="fc.email.invalid && fc.email.touched"
                        [attr.aria-describedby]="fc.email.errors ? 'forgotEmailError' : null">
                    <div *ngIf="fc.email.errors" id="forgotEmailError" class="invalid-feedback" role="alert">
                        <div *ngIf="fc.email.errors.required">
                            Please enter your email
                        </div>
                        <div *ngIf="fc.email.errors.email">
                            Please enter valid email
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedHelpType === passwordResetType.ResetPassword">
                    <div class="text-box-wrap">
                        <label for="verificationCode" class="sr-only">Verification Code</label>
                        <input type="text" id="verificationCode" formControlName="verificationCode" class="form-control" maxlength="3"
                            (keypress)="isNumber($event)" placeholder="Verification Code" autocomplete="one-time-code" aria-required="true"
                            [ngClass]="{'is-invalid': formErrors.verificationCode}"
                            [attr.aria-invalid]="fc.verificationCode.invalid && fc.verificationCode.touched"
                            [attr.aria-describedby]="fc.verificationCode.errors ? 'verificationCodeError' : null">
                        <div *ngIf="fc.verificationCode.errors" id="verificationCodeError" class="invalid-feedback" role="alert">
                            <div *ngIf="fc.verificationCode.errors.required">
                                Please enter verification code received in email
                            </div>
                        </div>
                    </div>
                    <div class="text-box-wrap">
                        <label for="forgotNewPassword" class="sr-only">New Password</label>
                        <input type="password" id="forgotNewPassword" formControlName="password" class="form-control" maxlength="50"
                            placeholder="New Password" autocomplete="new-password" aria-required="true"
                            [ngClass]="{'is-invalid': formErrors.password}"
                            [attr.aria-invalid]="fc.password.invalid && fc.password.touched"
                            [attr.aria-describedby]="fc.password.errors ? 'forgotNewPasswordError' : null">
                        <div *ngIf="fc.password.errors" id="forgotNewPasswordError" class="invalid-feedback" role="alert">
                            <div *ngIf="fc.password.errors.required">
                                Please enter new password
                            </div>
                        </div>
                    </div>
                    <div class="text-box-wrap">
                        <label for="forgotConfirmPassword" class="sr-only">Confirm Password</label>
                        <input type="password" id="forgotConfirmPassword" formControlName="confirmPassword" class="form-control" maxlength="50"
                            placeholder="Confirm Password" autocomplete="new-password" aria-required="true"
                            [ngClass]="{'is-invalid': formErrors.confirmPassword}"
                            [attr.aria-invalid]="fc.confirmPassword.invalid && fc.confirmPassword.touched"
                            [attr.aria-describedby]="fc.confirmPassword.errors ? 'forgotConfirmPasswordError' : null">
                        <div *ngIf="fc.confirmPassword.errors" id="forgotConfirmPasswordError" class="invalid-feedback" role="alert">
                            <div *ngIf="fc.confirmPassword.errors.required">
                                Please enter confirm password
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="form-group" *ngIf="selectedHelpType !== passwordResetType.ResetPassword">
            <fieldset class="radio-wrap text-left" style="border: none; padding: 0; margin: 0;">
                <legend class="choose-option" style="font-size: 14px; font-weight: bold; margin-bottom: 8px;">CHOOSE HELP OPTION :</legend>
                <div class="custom-control custom-radio">
                    <input (change)="changeSelectedHelpType(passwordResetType.VerificationLink)" type="radio"
                        [checked]="true" class="custom-control-input" id="helpOptionTwo" name="rbHelpOptions">
                    <label class="custom-control-label" for="helpOptionTwo">Re-send Email Verification
                        Link</label>
                </div>
                <div class="" style="height:10px;"></div>
                <div class="custom-control custom-radio">
                    <input (change)="changeSelectedHelpType(passwordResetType.VerificationCode)" type="radio"
                        class="custom-control-input" id="helpOptionOne" name="rbHelpOptions">
                    <label class="custom-control-label" for="helpOptionOne">Help Reset my Password</label>
                </div>
            </fieldset>
        </div>
        <div class="form-group">
            <button type="button" [disabled]="!forgotPasswordForm.valid" [ngStyle]="clientConfig.style.bg"
                (click)="onSubmit()" class="app-btn btn btn-danger btn-block">Submit</button>
        </div>
    </div>
</div>